import {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {IElement} from '../../incase-domain/elements';
import {selectedSlideSelector} from '../../store/selectors/slide.selectors';
import {useSlideUpdateContext} from '../../ui/context/SetSlideUpdateContext';
import {shapeElementTypes} from '../../incase-domain/elements/base/ElementTypes';

function getMobileOrder(element: IElement): number {
    return typeof element.mobileOrder === 'number' && Number.isFinite(element.mobileOrder) ? element.mobileOrder : Number.MAX_SAFE_INTEGER;
}

export function useSortMobileElements(): IElement[] {
    const slide = useSelector(selectedSlideSelector);
    const {setSlide} = useSlideUpdateContext();

    function sortMobileElements(elements: IElement[]): IElement[] {
        return [...elements].sort((a, b) => {
            const orderA = getMobileOrder(a);
            const orderB = getMobileOrder(b);
            return orderA - orderB || a.elementIndex - b.elementIndex;
        });
    }

    useEffect(() => {
        const mobileElements = slide.elements
            .filter((element) => element.hideOnMobile !== true)
            .filter((element) => !shapeElementTypes.includes(element.type));
        const sortedMobile = sortMobileElements(mobileElements);

        const needsUpdate = sortedMobile.some((el, index) => el.mobileOrder !== index);
        if (!needsUpdate) return;

        const orderMap = new Map(sortedMobile.map((el, index) => [el.id, index]));
        const newElements = slide.elements.map((el, elementIndex) => ({
            ...el,
            elementIndex,
            mobileOrder: orderMap.get(el.id),
        }));

        setSlide({...slide, elements: [...newElements]});
    }, [setSlide, slide]);

    return useMemo((): IElement[] => {
        const mobileElements = slide.elements
            .filter((element) => element.hideOnMobile !== true)
            .filter((element) => !shapeElementTypes.includes(element.type));

        return sortMobileElements(mobileElements);
    }, [slide.elements]);
}
